import { render } from "./TheSidebarMenu.vue?vue&type=template&id=43894955&scoped=true"
import script from "./TheSidebarMenu.vue?vue&type=script&lang=js"
export * from "./TheSidebarMenu.vue?vue&type=script&lang=js"

import "./TheSidebarMenu.vue?vue&type=style&index=0&id=43894955&lang=scss&scoped=true"
import "./TheSidebarMenu.vue?vue&type=style&index=1&id=43894955&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43894955"]])

export default __exports__